import getApiConfig from '../config/apiConfig';

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
  return response.json();
};

// Helper function to replace tokens in email templates
const replaceTokens = (template, tokens) => {
  // Handle case-sensitive property names
  let subject = template.Subject || template.subject;
  let body = template.TemplateBody || template.templateBody;

  if (!subject || !body) {
    console.error('Template is missing required fields:', { subject, body });
    throw new Error('Template is missing required fields');
  }

  // Replace tokens in subject and body
  Object.keys(tokens).forEach(key => {
    const tokenPattern = new RegExp(`{${key}}`, 'gi');
    let tokenValue = tokens[key] || '';
    
    // For the body (HTML content), convert line breaks to <br> tags
    const htmlTokenValue = tokenValue.toString().replace(/\r\n|\n|\r/g, '<br>');
    
    // Replace in subject (plain text - no HTML conversion)
    subject = subject.replace(tokenPattern, tokenValue);
    
    // Replace in body (HTML - with line break conversion)
    body = body.replace(tokenPattern, htmlTokenValue);
  });

  // Return the complete template with all original fields preserved
  const result = {
    ...template,
    subject: subject,  // Keep lowercase for consistency in the email service
    templateBody: body,  // Keep lowercase for consistency in the email service
    Subject: subject,  // Keep uppercase for backward compatibility
    TemplateBody: body  // Keep uppercase for backward compatibility
  };
  
  return result;
};

export const emailTemplateService = {
  // Get all email templates
  async getEmailTemplates() {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/emailtemplates`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting email templates:', error);
      throw error;
    }
  },

  // Get email template by name
  async getEmailTemplateByName(name) {
    try {
      const { apiBaseUrl } = getApiConfig();
      const response = await fetch(`${apiBaseUrl}/emailtemplates/${encodeURIComponent(name)}`);
      return handleResponse(response);
    } catch (error) {
      console.error('Error getting email template by name:', error);
      throw error;
    }
  },

  // Replace tokens in email template
  replaceTokens
};
